import React from 'react';
import ReactDOM from 'react-dom';
// import * as Sentry from '@sentry/react';
import App from './App';

// Sentry.init({dsn: "https://77d30d679de84c36b37ed3775462f569@o422420.ingest.sentry.io/5348482"});

ReactDOM.render(<App />, document.querySelector('#root'));